/**
 * TEMPORARY FORCED-QUOTE OVERRIDE
 *
 * Certain values of the `Contenido` option temporarily resolve to `quote`,
 * regardless of the product-level sales mode. The current business rule is
 * `200 L` → `quote`; only exterior whitespace of commercial values is ignored.
 *
 * This pure compatibility layer must be removed when sales_mode is migrated to
 * ProductVariant metafields.
 */
(() => {
  const normalizeOptionName = (value) => String(value || '').trim().toLocaleLowerCase();
  const normalizeCommercialValue = (value) => String(value || '').trim();

  const getEffectiveSalesMode = ({ baseSalesMode, selectedOptions, overrideConfig } = {}) => {
    const baseMode = ['direct', 'hybrid', 'quote'].includes(baseSalesMode) ? baseSalesMode : 'quote';
    const optionName = normalizeOptionName(overrideConfig?.optionName);
    const forcedValues = Array.isArray(overrideConfig?.forcedQuoteValues)
      ? overrideConfig.forcedQuoteValues.map(normalizeCommercialValue)
      : [];

    const selectedContenido = Array.isArray(selectedOptions)
      ? selectedOptions.find((option) => normalizeOptionName(option?.name) === optionName)?.value
      : undefined;

    return forcedValues.includes(normalizeCommercialValue(selectedContenido)) ? 'quote' : baseMode;
  };

  window.BemaltForcedQuoteOverride = Object.freeze({ getEffectiveSalesMode });
})();
